export const FEED_EVENT = 'feed'
export const STORY_EVENT = 'story'
export const EXCEPTION_EVENT = 'exception'
export const REACTION_CREATED_EVENT = 'reaction-created'
export const REACTION_UPDATED_EVENT = 'reaction-updated'
export const NOTIFICATIONS_LOADED_EVENT = 'notifications-loaded'
export const NOTIFICATIONS_LOADED_MORE_EVENT = 'notifications-loaded-more'
export const NOTIFICATIONS_UNREAD_COUNT_LOADED_EVENT = 'notifications-unread-count-loaded'
export const NOTIFICATIONS_MARKED_READ = 'notifications-marked-read'
export const STORY_ACTIVITY_LOADED = 'story-activity-loaded'
export const STORY_UPDATED_EVENT = 'story-updated'
export const STORIES_UNREAD_COUNT_LOADED_EVENT = 'stories-unread-count-loaded'
export const STORIES_MARKED_READ = 'stories-marked-read'
export const MENTION_CREATED = 'mention-created'
export const PEER_INVITE_ACCEPTED = 'peer-invite-accepted'

export default [
  FEED_EVENT,
  STORY_EVENT,
  EXCEPTION_EVENT,
  REACTION_CREATED_EVENT,
  REACTION_UPDATED_EVENT,
  NOTIFICATIONS_LOADED_EVENT,
  NOTIFICATIONS_LOADED_EVENT,
  NOTIFICATIONS_LOADED_MORE_EVENT,
  NOTIFICATIONS_UNREAD_COUNT_LOADED_EVENT,
  NOTIFICATIONS_MARKED_READ,
  STORY_ACTIVITY_LOADED,
  STORIES_UNREAD_COUNT_LOADED_EVENT,
  STORIES_MARKED_READ,
  MENTION_CREATED,
  STORY_UPDATED_EVENT,
  PEER_INVITE_ACCEPTED,
]
